module.exports = __webpack_public_path__ + "static/media/logo.0094da0c.png";